import React, { useContext } from "react";
import { Grid, Typography, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { SocketContext } from "../SocketContext";

const useStyles = makeStyles((theme) => ({
  video: {
    width: "550px",
    border: "1px solid black",
    borderRadius: "5%",
    [theme.breakpoints.down("xs")]: {
      //mobile devices width
      width: "300px",
    },
  },
  gridContainer: {
    justifyContent: "center", //on desktop devices
    [theme.breakpoints.down("xs")]: {
      //mobile devices
      flexDirection: "column",
    },
  },
  paper: {
    padding: "10px",
    backgroundColor: "#8696FE",
    border: "2px solid black",
    borderRadius: "3%",
    margin: "10px",
  },
  paper2: {
    padding: "10px",
    backgroundColor: "#08D9D6",
    border: "2px solid black",
    borderRadius: "3%",
    margin: "10px",
  },
}));

const VideoPlayer = () => {
  const {
    name,
    callAccepted,
    myVideo,
    userVideo,
    callEnded,
    stream,
    call,
  } = useContext(SocketContext);
  const classes = useStyles();

  return (
    <Grid container className={classes.gridContainer}>
      {/* Our Own Video */}
      {/* We won't see user's video until we call so we give condition */}
      {/* Only if there is stream then render our own stream  */}
      {/* We cannot show something if we do not have stream */}
      {stream && (
        <Paper className={classes.paper}>
          {/* Full width on mobile devices and half screen on desktop*/}
          <Grid item xs={12} md={6}>
            {/* gutterBottom = small margin on bottom */}
            <Typography variant="h5" gutterBottom>
              {name || "Name"}
            </Typography>
            {/* ref is main connection bw stream and video connection */}
            <video
              playsInline
              muted
              ref={myVideo}
              autoPlay
              className={classes.video}
            />
          </Grid>
        </Paper>
      )}

      {/* User's Video */}
      {callAccepted && !callEnded && (
        <Paper className={classes.paper2}>
          {/* Full width on mobile devices and half screen on desktop*/}
          <Grid item xs={12} md={6}>
            {/* gutterBottom = small margin on bottom */}
            <Typography variant="h5" gutterBottom>
              {call.name || "Name"}
            </Typography>
            <video
              playsInline
              ref={userVideo}
              autoPlay
              className={classes.video}
            />
          </Grid>
        </Paper>
      )}
    </Grid>
  );
};

export default VideoPlayer;
